<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'spmComCost/getComCostAndTime';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.comCostAndTime')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[

        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    ]
            },
             {
                title:`${this.$t('onlineDoc.请求参数')}`,
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
             {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
                {name: "digest",type: "String(50)",require: "Y",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe: `${this.$t('onlineDoc.digestnew')}`},
                {name: "destinationZipCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.目的地邮编')}`},
                {name: "originZipCode",type: "String",require: "N",normal: "",describe:`${this.$t('onlineDoc.始发地邮编')}`},

                {name: "productTypeCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.产品类型编码')}`},
                {name: "weight",type: "String",require: "Y",normal: "0.02",describe: `${this.$t('onlineDoc.重量（正数），单位kg，范围0.01-30，为空默认0.02')}`},
                {name: "insuredAmount",type: "String",require: "N",normal: "1.01",describe:  `${this.$t('onlineDoc.物品价值')}`},
                {name: "goodsTypeCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品类型编码')}`},
                {name: "serviceMethodCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.服务方式编码')}`},
                {name: "smMode",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.结算方式(1:寄件现结,2寄付月结,3:到付现结)')}`},
                {name: "quoteType",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.报价类型, 0: 普通报价， 1：同城报价，2：同省报价')}`}
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`},
                  ]
            },

            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "cost",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.运费')}`},
                  {name: "riskPremiumFee",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.保险费+风险费')}`},
                  {name: "riskPremiumWaybillFee",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.保险费+风险费+运单运费')}`},
                  {name: "aging",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.时效/天')}`},
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {
      "customerCode": "J0086024271",
      "destinationZipCode": "08570-431",
      "digest": "/5lzUeRhMDdJ0IClechueg==",
      "goodsTypeCode": "bm000001",
      "productTypeCode": "EZ",
      "weight": "20"}`,
        //返回示例
        responseCode: JSON.parse(
          `{"code":"1","msg":"success","data":{"cost":"0","aging":0,"riskPremiumFee":"0","riskPremiumWaybillFee":"0"}}`
          ),

       //错误代码提示
        errcodeJson: []
      },


      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"customerCode":"J0086024271","destinationZipCode":"08570-431","digest":"/5lzUeRhMDdJ0IClechueg==","goodsTypeCode":"bm000001","productTypeCode":"EZ","weight":"20"}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
       //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
